/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelActionCode.ts                    *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/action-code";

export class AutogenModelActionCode<RowType extends ModelRow> extends Endpoint<RowType, RowActionCodeFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowActionCode extends ModelRow<RowActionCodeFields> {
	constructor(values?: Partial<RowActionCodeFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowActionCodeFields {
	company_id: string;
	descr: string;
	id: string;
	nxt_action_code_id: string;
	nxt_action_days: number;
}

